import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, CycleOocyteQualityBetweenDateController, CycleOocyteQualityBetweenDateRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, OocyteMaturityByCycleController, OocyteMaturityByCycleRequest, OocyteMorphologyByCycleController, OocyteMorphologyByCycleRequest, CounsellingActivitiesByTimeController, SaveCounsellingActivityRequest, CounsellingActivitiesByTimeRequest, CounsellingPlanController, CounsellingPlanRequest, MaterialBatchInaStoreRequest, MaterialBatchInaStoreController, ItemWiseSalesRequest, ItemWiseSalesController, ItemWiseServiceRequest, ItemWiseServiceController } from '../../../../../../../src/app/ncs/models/actor/actor';
import { OocyteStoreItem } from '../../../testnurse/ivf/ivfworkbench/ivfoqaedit.component';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Subscription } from 'rxjs';




@Component({
  selector: 'servicesrevenuePV',
  templateUrl: './servicesrevenuePV.component.html',
  styleUrls: ['./servicesrevenuePV.component.scss']
})

export class ServicesrevenuePVComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  public OQACode: any;
  public Owner: string;
  public ActorCode: number = 0;
  public diff: number = 0;
  public Add: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsToday: boolean = false;
  public IsDuration: boolean = true;
    public IsExpand: boolean = true;
    public SelectedDateNew: Date;
  //public isRequesting: boolean = false;
  public ShowMonitoring: boolean = false;
  public ShowTracking: boolean = true;
  public Showarrow: boolean = false;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public FSelectedDay: any;
  public FSelectedMonth: any;
  public FSelectedYear: any;
  public TSelectedDay: any;
  public TSelectedMonth: any;
  public TSelectedYear: any;
  public MaterialCode: any;
  public Description: any;
  public GroupName: any;
  public ItemCode: any;
  //public ApiResData: ApiResponseModel;
  SelectedToDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  SelectedFromDate2: Date;
  SelectedFromDate3: NgbDateStruct;

  dateI: NgbDateStruct;
  TodayDate = new Date();
  Datediffer = new Date();

  public nofsales: number;
  public Totalsales: number;
  public TotalDiscountsa: number;
  public TotalTax: number;
  public GrandTotal: number;
  public length2: number;

  sub: Subscription;


  CurrentItemWiseServiceRequest: ItemWiseServiceRequest;
  CurrentItemWiseServiceController: ItemWiseServiceController[];
  LoadSales2() {
    //this.spinner.show();
    this.CurrentItemWiseServiceRequest = new ItemWiseServiceRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;
    this.CurrentItemWiseServiceRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentItemWiseServiceRequest.ConditionalOperator = 10;
    this.CurrentItemWiseServiceRequest.StoreCode = 0;
    this.CurrentItemWiseServiceRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentItemWiseServiceRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentItemWiseServiceRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedToDate));
    this.CurrentItemWiseServiceRequest.ItemCode = this.ItemCode;
    //this.CurrentConsumptionGroupItemsRequest = new Array<ServicesByCategoryCodeController>();

    this.GetItemWiseServiceController();

  }

  GetItemWiseServiceController() {
    this.StartRefreshing();
    this.actorservice.GetItemWiseServiceController(this.CurrentItemWiseServiceRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentItemWiseServiceController = this.ApiResData.Result;
          this.nofsales = this.CurrentItemWiseServiceController.length;
          this.Totalsales = this.CurrentItemWiseServiceController.filter(l => l.Total)
            .reduce((sum, current) => sum + current.Total, 0);
          this.TotalDiscountsa = this.CurrentItemWiseServiceController.filter(l => l.Discount)
            .reduce((sum, current) => sum + current.Discount, 0);

          this.GrandTotal = this.CurrentItemWiseServiceController.filter(l => l.BeforeDiscount)
            .reduce((sum, current) => sum + current.BeforeDiscount, 0);

          this.length2 = this.CurrentItemWiseServiceController.length;

          this.stopRefreshing();
          this.LoadCounselling();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();


          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  CurrentCounsellingPlanController: CounsellingPlanController[];
  CurrentCounsellingPlanRequest: CounsellingPlanRequest;

  LoadCounselling() {

    this.CurrentCounsellingPlanRequest = new CounsellingPlanRequest();
    this.CurrentCounsellingPlanRequest.ActorCode = this.ActorCode.toString();
    this.CurrentCounsellingPlanRequest.BranchCode = AppData.Instance().SelectedBranchCode;

    //alert(this.ActorCode);
    this.CurrentCounsellingPlanRequest.ConditionalOperator = 20;
    this.CurrentCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCounsellingPlanController();
  }
  //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
  GetCounsellingPlanController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetCounsellingPlanController(this.CurrentCounsellingPlanRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

            this.CurrentCounsellingPlanController = this.ApiResData.Result;
            
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();
          this.printService.onDataReady();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp");
    //this.Date = new Date();

    //this.SelectedFromDate = this.route.snapshot.paramMap.get('SelectedFromDate');
    this.FSelectedDay = this.route.snapshot.paramMap.get('FDay');
    this.FSelectedMonth = this.route.snapshot.paramMap.get('Fmonth');
    this.FSelectedYear = this.route.snapshot.paramMap.get('Fyear');
    this.SelectedFromDate = { year: this.FSelectedYear, month: this.FSelectedMonth, day: this.FSelectedDay };
    this.MaterialCode = this.route.snapshot.paramMap.get('MaterialCodeData');
    this.TSelectedDay = this.route.snapshot.paramMap.get('TDay');
    this.TSelectedMonth = this.route.snapshot.paramMap.get('Tmonth');
    this.TSelectedYear = this.route.snapshot.paramMap.get('Tyear');
    this.SelectedToDate = { year: this.TSelectedYear, month: this.TSelectedMonth, day: this.TSelectedDay };
    this.Description = this.route.snapshot.paramMap.get('DescriptionData');
    this.GroupName = this.route.snapshot.paramMap.get('GroupNameData'); 
    this.ItemCode = this.route.snapshot.paramMap.get('ItemCodeData');
    this.LoadSales2();
    //this.CurrentEditCounsellingActivityRequest = new SaveCounsellingActivityRequest;
    //this.CurrentEditCounsellingActivityRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 2, day: this.TodayDate.getDate() };
    //this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };


  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
 

}








